<template>
  <div class="shops-detail-info">
    <!-- 通过shopid来判断页面数据获得 -->
    <ul class="info-form" v-if="shopData.id">
      <li class="form-item" v-if="OPENED">
        <span class="form-item-label">店铺logo：</span>
        <div class="form-item-content">
          <img v-pic="shopData.logoFiles[0] ? shopData.logoFiles[0].content.location : ''" />
        </div>
        <span class="form-item-label">店铺ID：</span>
        <div class="form-item-content">
          {{ shopData.id }}
        </div>
      </li>
      <li class="form-item">
        <span class="form-item-label">店铺名称：</span>
        <div class="form-item-content">
          <i class="el-icon-circle el-icon-s-shop" style="background-color:#005bff;"></i>
          <span>{{ shopData.name }}</span>
        </div>
        <span class="form-item-label">卖家账号昵称：</span>
        <div class="form-item-content">
          <i class="el-icon-circle el-icon-user-solid" style="background-color:#00bd83;"></i>
          <span>{{ shopData.userInfo.nickname || '- -' }}</span>
        </div>
      </li>
      <li class="form-item">
        <span class="form-item-label description">经营地址：</span>
        <div class="form-item-content">{{ shopData.region.replace(/,/g, ' ') }} {{ shopData.address }}</div>
      </li>
      <li class="form-item" v-if="ENTERPRISE">
        <span class="form-item-label">联系人姓名：</span>
        <div class="form-item-content">{{ shopData.contact ? shopData.contact.name || '- -' : '- -' }}</div>
      </li>
      <li class="form-item">
        <span class="form-item-label">手机号：</span>
        <div class="form-item-content">
          {{ shopData.contact ? shopData.contact.phone || '- -' : '- -' }}
        </div>
        <span class="form-item-label">邮箱：</span>
        <div class="form-item-content">
          {{ shopData.contact ? shopData.contact.email || '- -' : '- -' }}
        </div>
      </li>
      <template v-if="OPENED">
        <li class="form-item">
          <span class="form-item-label">客服电话：</span>
          <div class="form-item-content">
            {{ shopData.customerPhone || '- -' }}
          </div>
        </li>
        <li class="form-item">
          <span class="form-item-label">店铺关键词：</span>
          <div class="form-item-content">
            {{ shopData.keywords || '- -' }}
          </div>
        </li>
        <li class="form-item">
          <span class="form-item-label description">店铺介绍：</span>
          <div class="form-item-content description">
            {{ shopData.storeIntroduce ? shopData.storeIntroduce.introduce || '- -' : '- -' }}
          </div>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'shopDetailInfo',
  props: ['shopData', 'OPENED', 'ENTERPRISE']
};
</script>

<style lang="scss">
.shops-detail-info {
  min-height: 100px;
  .form-item {
    margin-top: 20px;
    display: flex;
    align-items: center;
    &:first-child {
      margin-top: 0;
    }
    &-content {
      max-width: 760px;
      width: 260px;
    }
    &-label {
      min-width: 70px;
    }
    &-label.description {
      line-height: 20px;
      align-self: flex-start;
    }
    &-content.description {
      line-height: 20px;
      max-width: 720px !important;
      width: 720px !important;
    }
  }
}
</style>
